import { apiRequest } from '@/core';
import { type ChangePasswordPayload } from '@/slices/user/types';

export const changePasswordRequest = async (
  changedUser: ChangePasswordPayload,
) =>
  apiRequest<void>({
    endpoint: 'api/user/password',
    body: changedUser,
  });
